import React from 'react';
import { JobT } from '../../types/Job';
import { UserRegisterT } from './RegisterScreen';

export type IRegisterJobInfoTabProps = {
    fields: UserRegisterT
    onChangeField(key: string, value: any): void
    job : JobT
    nextTab() : void
    updateJob(key : string, value : any) : void
}

const RegisterJobInfoTab: React.FC<IRegisterJobInfoTabProps> = (props) => {
    return (
        <div>
            
        </div>
    );
}

export default RegisterJobInfoTab